import React from 'react';
import  "./btnStyle.scss";

const PrimaryButton = ({ label, onClick, disabled }) => {
  return (
    <button
      className="btn btn-primary"
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default PrimaryButton;
